import { app } from '../../app.module'
app
  /**
   * エンターイベント発火用
   */
  .directive('ngEnter', function () {
    return {
      link: function (scope, element, attrs) {
        element.bind('keydown', function (event) {
          if (event.which === 13) {
            scope.$apply(function () {
              scope.$eval(attrs.ngEnter)
            })
          }
        })
      },
    }
  })
